/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Seconds_LabelInputs */

const en_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seconds`)
};

const fr_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondes`)
};

const de_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekunden`)
};

const it_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondi`)
};

const ru_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Секунды`)
};

const es_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos de segunda clase`)
};

const zh_cn2_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒`)
};

const ja_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒`)
};

const hi_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेकंड`)
};

const pt_pt2_summary_seconds_label = /** @type {(inputs: Summary_Seconds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundos`)
};

/**
* | output |
* | --- |
* | "Seconds" |
*
* @param {Summary_Seconds_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_seconds_label = /** @type {((inputs?: Summary_Seconds_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Seconds_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_seconds_label(inputs)
	if (locale === "de") return de_summary_seconds_label(inputs)
	if (locale === "it") return it_summary_seconds_label(inputs)
	if (locale === "ru") return ru_summary_seconds_label(inputs)
	if (locale === "es") return es_summary_seconds_label(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_seconds_label(inputs)
	if (locale === "ja") return ja_summary_seconds_label(inputs)
	if (locale === "hi") return hi_summary_seconds_label(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_seconds_label(inputs)
	return en_summary_seconds_label(inputs)
});